import { render, staticRenderFns } from "./arrangeBedroom.vue?vue&type=template&id=40ca6e9e&scoped=true"
import script from "./arrangeBedroom.vue?vue&type=script&lang=js"
export * from "./arrangeBedroom.vue?vue&type=script&lang=js"
import style0 from "./arrangeBedroom.vue?vue&type=style&index=0&id=40ca6e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca6e9e",
  null
  
)

export default component.exports